import { render, staticRenderFns } from "./PartnerPriceList.vue?vue&type=template&id=a0f4cb32&scoped=true&"
import script from "./PartnerPriceList.vue?vue&type=script&lang=js&"
export * from "./PartnerPriceList.vue?vue&type=script&lang=js&"
import style0 from "./PartnerPriceList.vue?vue&type=style&index=0&id=a0f4cb32&lang=scss&scoped=true&"
import style1 from "./PartnerPriceList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f4cb32",
  null
  
)

export default component.exports